module.exports = __webpack_public_path__ + "media/images/product-banners/debt-modeller-a10f6c1b4f21aa4caf8604b2836a54be.svg";